'use client';

import React from 'react';
import Link from 'next/link';
import { useParams, usePathname } from 'next/navigation';
import Divider from '@mui/material/Divider';
import { useBodyClassName } from '@/utils/hooks';
import styles from './styles.module.scss';

interface Props {
  children: React.ReactNode;
}

const siteMapTabs = [
  {
    title: '地图首页',
    path: '/sitemap/',
  },
  {
    title: '职场数据页',
    path: '/sitemap/job-title/',
  },
  {
    title: '城市职场数据页',
    path: '/sitemap/job-title-city/',
  },
  {
    title: '职场排名页',
    path: '/sitemap/jobranking/',
  },
  {
    title: '城市职场排名页',
    path: '/sitemap/jobranking-city/',
  },
  {
    title: '城市数据页',
    path: '/sitemap/city/',
  },
  {
    title: '公司公开页',
    path: '/sitemap/company/',
  },
  {
    title: '文章页',
    path: '/sitemap/article/',
  },
];

const PageFrame = (props: Props) => {
  const { children } = props;
  const pathname = usePathname();
  const params = useParams() || null;
  const fullParams = params ? Object.values(params).join('/') : '';

  useBodyClassName('bg-[#f8f7fa]');

  return (
    <div className={`py-9 px-32 ${styles.sitemap}`}>
      <div className={`bg-white px-8 py-6 ${styles.sitemapHead}`}>
        <ul className="text-lg flex flex-row">
          {siteMapTabs.map(({ path, title }) => (
            <li
              key={path}
              className={
                (
                  fullParams
                    ? pathname?.includes(path + fullParams)
                    : pathname === path
                )
                  ? 'text-web-blue-500'
                  : ''
              }
            >
              <Link href={path}>{title}</Link>
            </li>
          ))}
        </ul>
      </div>
      <Divider />
      {children}
    </div>
  );
};

export default PageFrame;
